import { useState } from "react";
import { FiDownload, FiEye } from "react-icons/fi";
import { FuturisticLoadingSpinner } from "../loading-spinner";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog";
import { Download, ExternalLink } from "lucide-react";
import { RESUME_AR_LINK, RESUME_EN_LINK, RESUME_FR_LINK } from "@/lib/constants";

// interface ResumeModalProps {
//     open: boolean;
//     setOpen: (v: boolean) => void;
// }

export function DownloadResumeModal() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)

    const handleDownload = (language: 'english' | 'french' | 'arabic' = 'english') => {
        const resumePath = `/resume/hamza-missaoui-resume-${language.slice(0, 2).toLowerCase()}.pdf`;
        const fileName = `hamza-missaoui-resume-${language.slice(0, 2).toLowerCase()}.pdf`;
        setLoading(true);


        try {
            const link = document.createElement('a');
            link.href = resumePath; // Path to your PDF file in the public directory
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={isModalOpen} onOpenChange={setIsModalOpen} modal>
            <DialogTrigger asChild className="w-0 h-0">
                {/* {children} */}
                <Button
                    // onClick={() => setIsModalOpen(true)}
                    className='w-full h-12 bg-background border-border text-foreground hover:bg-accent hover:text-accent-foreground'
                    variant="outline">
                    <Download className='mr-2 h-4 w-4' />
                    My Resume
                </Button>
            </DialogTrigger>

            <DialogContent className="bg-card border-border rounded-xl p-6 shadow-2xl max-w-md">
                {/* Close button */}
                <DialogHeader>
                    {/* <Button
                        onClick={() => setOpen(false)}
                        aria-label="Close resume modal"
                        className="absolute top-4 right-4 p-1.5 rounded-full hover:bg-accent hover:text-accent-foreground bg-transparent border-0"
                        variant="ghost"
                    >
                        <FiX className="text-muted-foreground" size={20} />
                    </Button> */}

                    <DialogTitle className="text-lg font-semibold text-card-foreground mb-4">
                        My Resume
                    </DialogTitle>

                    <DialogDescription className="text-sm text-muted-foreground mb-6">
                        Choose the version you want to download.
                    </DialogDescription>
                </DialogHeader>

                <div className="flex flex-col gap-3">
                    <Button
                        onClick={() => handleDownload("english")}
                        className="flex items-center justify-center gap-2 bg-background border-border text-foreground hover:bg-accent hover:text-accent-foreground h-12"
                        variant="outline"
                    >
                        <span className="text-2xl">🇬🇧</span>
                        <span>Download English Version</span>
                        <FiDownload className="text-primary" />
                        {loading && <FuturisticLoadingSpinner />}
                    </Button>

                    <Button
                        onClick={() => handleDownload("french")}
                        className="flex items-center justify-center gap-2 bg-background border-border text-foreground hover:bg-accent hover:text-accent-foreground h-12"
                        variant="outline"
                    >
                        <span className="text-2xl">🇫🇷</span>
                        {/* <span>Télécharger la version française</span> */}
                        <span>Downlaod French Version</span>
                        <FiDownload className="text-primary" />
                        {loading && <FuturisticLoadingSpinner />}
                    </Button>


                    <Button
                        onClick={() => handleDownload("arabic")}
                        className="flex items-center justify-center gap-2 bg-background border-border text-foreground hover:bg-accent hover:text-accent-foreground h-12"
                        variant="outline"
                    >
                        <span className="text-2xl">🇹🇳</span>
                        {/* <span>Downlaod Arabic Version</span> */}
                        <span>تحميل النسخة العربية</span>
                        <FiDownload className="text-primary" />
                        {loading && <FuturisticLoadingSpinner />}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}


// export function ViewResumeModal({ open, setOpen }: ResumeModalProps) {
export function ViewResumeModal() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleView = (language: 'english' | 'french' | 'arabic' = 'english') => {
        window.open(language === "english" ? RESUME_EN_LINK : language === "french" ? RESUME_FR_LINK : language === "arabic" ? RESUME_AR_LINK : RESUME_EN_LINK, '_blank');
    };

    return (
        <Dialog open={isModalOpen} onOpenChange={setIsModalOpen} modal>
            <DialogTrigger asChild className="w-0 h-0">
                <Button
                    variant='outline'
                    className='w-full h-12 bg-background border-border text-foreground hover:bg-accent hover:text-accent-foreground'>
                    <ExternalLink className='mr-2 h-4 w-4' />
                    View Resume
                </Button>
            </DialogTrigger>

            <DialogContent className="bg-card border-border rounded-xl p-6 shadow-2xl max-w-md">
                {/* Close button */}
                <DialogHeader>
                    {/* <Button
                        onClick={() => setOpen(false)}
                        aria-label="Close resume modal"
                        className="absolute top-4 right-4 p-1.5 rounded-full hover:bg-accent hover:text-accent-foreground bg-transparent border-0"
                        variant="ghost"
                    >
                        <FiX className="text-muted-foreground" size={20} />
                    </Button> */}

                    <DialogTitle className="text-lg font-semibold text-card-foreground mb-4">
                        Resume to View
                    </DialogTitle>

                    {/* <DialogDescription className="text-sm text-muted-foreground mb-6">
                        Choose the version you want to download.
                    </DialogDescription> */}
                </DialogHeader>

                <div className="flex flex-col gap-3">
                    <Button
                        onClick={() => handleView("english")}
                        className="flex items-center justify-center gap-2 bg-background border-border text-foreground hover:bg-accent hover:text-accent-foreground h-12"
                        variant="outline"
                    >
                        {/* <span className="text-xl">🇬🇧</span> */}
                        <span>View English Version</span>
                        <FiEye className="text-primary" />
                        {/* {loading && <FuturisticLoadingSpinner />} */}
                    </Button>

                    <Button
                        onClick={() => handleView("french")}
                        className="flex items-center justify-center gap-2 bg-background border-border text-foreground hover:bg-accent hover:text-accent-foreground h-12"
                        variant="outline"
                    >
                        <span>View French Version</span>
                        <FiEye className="text-primary" />
                    </Button>

                    <Button
                        onClick={() => handleView("arabic")}
                        className="flex items-center justify-center gap-2 bg-background border-border text-foreground hover:bg-accent hover:text-accent-foreground h-12"
                        variant="outline"
                    >
                        <span>View Arabic Version</span>
                        <FiEye className="text-primary" />
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}